export const PATHS = {
  HOME: '/',
  FAVOURITES: '/favourites',
  CART: '/cart',
  PHONES: {
    LIST: '/phones',
    DETAILS: '/phones/:phoneID',
  },
  TABLETS: {
    LIST: '/tablets',
    DETAILS: '/tablets/:tabletID',
  },
  ACCESSORIES: {
    LIST: '/accessories',
    DETAILS: '/accessories/:accessoriesID',
  },
};
